import { render, staticRenderFns } from "./BookmarkBtn.vue?vue&type=template&id=339de7d2"
import script from "./BookmarkBtn.vue?vue&type=script&lang=ts"
export * from "./BookmarkBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports